import React from 'react';
import Inner from './Inner';

const Footer = () => {
  return (
    <footer>
      <Inner>
      ✌️ Created by <a href="https://twitter.com/ispykenny" target="_blank" rel="noreferrer">Kenny Krosky</a> (Not affilated with Dribbble) <span>Background image credit: <a href="https://twitter.com/danielkorpai" target="_blank" rel="noreferrer">@danielkorpai</a></span>
      </Inner>
    </footer>
  )
}
export default Footer;